<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="storehouse">
    <div class="w overflow-hidden">
      <Row class="component-title">
        <Col span="24">智慧生物信息库</Col>
      </Row>
      <Row class="storehouse-content overflow-hidden">
        <Col
          v-for="child in storehouses"
          :key="child.id"
          span="8"
          class="h-full content"
          @click.native="link(child.link)"
        >
          <div class="storehouse-content-box w-full h-full cursor-pointer">
            <div
              class="storehouse-image"
              :style="`background-image: url(${child.image});`"
            ></div>
            <Row
              type="flex"
              justify="center"
              align="middle"
              class="w-full storehouse-detail"
            >
              <Col span="18" class="detail-title">
                {{ child.title }}
              </Col>
              <Col span="6" class="detail-title text-right">
                <Button type="text" class="more">
                  详情<Icon type="ios-arrow-forward" />
                </Button>
              </Col>
              <Col span="24" class="detail-text">
                {{ child.content }}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'storehouseComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      storehouses: [
        {
          id: '1-1',
          title: '临床信息库',
          content:
            '患者诊疗信息的结构化数据的存储，数据标准遵循电子病历基本数据集标准。',
          link: 'waiting',
          image: '/static/images/background/information2.png'
        },
        {
          id: '1-2',
          title: '医学影像库',
          content: '以数字化方式收集、存储、管理医学影像信息。',
          link: 'waiting',
          image: '/static/images/background/information3.png'
        },
        {
          id: '1-3',
          title: '癌症库',
          content: '提供肿瘤样本信息及资源。',
          link: 'waiting',
          image: '/static/images/background/information4.png'
        },
        {
          id: '1-4',
          title: '生殖医学库',
          content:
            '存储生殖助孕及遗传学方面的样本，助孕技术包括人工授精、体外授精-胚胎移植及其衍生技术。',
          link: 'waiting',
          image: '/static/images/background/information5.png'
        },
        {
          id: '1-5',
          title: '出生缺陷库',
          content:
            '孕前-孕期出生人口队列及生物样本库，针对有出生缺陷的孕妇，收集其外周血、脐带、胎盘、头发等...',
          link: 'waiting',
          image: '/static/images/background/information6.png'
        },
        {
          id: '1-6',
          title: '基因信息库',
          content: '特定人群中个体所拥有的全部基因信息。',
          link: 'waiting',
          image: '/static/images/background/information7.png'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  methods: {
    link(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.storehouse {
  background-color: #fafafa;
  padding-bottom: 2.6vw; //50px;
  border-bottom: 1px solid #f0f1f2;

  .component-title {
    padding: 3.59vw 0 2.97vw 0; //69px 0 57px 0;
  }
  .content {
    padding-right: 1.875vw; //36px;
    padding-bottom: 1.77vw; //34px;
    height: 22.6vw; //434px;
  }
  .storehouse-image {
    height: 9.17vw; //176px;
    background-image: url('/static/images/background/storehouse1.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
  }
  .storehouse-content-box {
    padding: 1.46vw 1.46vw 0 1.46vw; //28px 28px 0 28px;
    border-radius: 4px;
    background: #ffffff;
    border: 1px solid #f0f1f2;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover,
    &.active {
      background: #46bfb8;
      box-shadow: 0px 0.52vw 1.67vw rgba(60, 171, 165, 0.3); //0px 10px 32px rgba(60, 171, 165, 0.3);
      border: 0 none;
      color: $c-white;
      .detail-title {
        border-bottom: 1px solid #f0f1f240;
      }
      .detail-title,
      .detail-text,
      .more,
      .ivu-icon {
        color: $c-white;
      }
    }
  }

  .detail-title {
    height: 4.58vw; //88px;
    line-height: 4.58vw; //88px;
    font-size: 1.25vw; //24px;
    color: #111a2e;
    border-bottom: 1px solid #f0f1f2;
    .more {
      font-size: 1.04vw; //20px;
      color: #46bfb8;
      padding: 0;
      &:hover {
        background-color: $c-transparent;
      }
    }
    .ivu-icon {
      margin-bottom: 4px;
      margin-right: -0.42vw; //-8px;
      margin-left: 0.42vw; //8px;
    }
  }
  .detail-text {
    padding-top: 1.2vw; //23px;
    color: #646a77;
    font-size: 1.04vw; //20px;

    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
  }
}
</style>
